import { LanguageSelect } from '~/components/language-select'

export const OnboardPage = () => <LanguageSelect className="w-full max-w-md" navigateTo="/cards" />
